import { NormalTextInputField } from "@/components";
import React from "react";

const MediaCenterFourthTabCMSFormFields = ({
  selectedTab,
  formData,
  isFetching,
  handleTextInputChange,
}) => {
  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="video-gallery-heading"
            fieldName="video-gallery-heading"
            placeholderText="Heading"
            inputValue={formData?.["video-gallery-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="video-gallery-description"
            fieldName="video-gallery-description"
            placeholderText="Description"
            inputValue={formData?.["video-gallery-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default MediaCenterFourthTabCMSFormFields;
